<template>
    <div class="trigger-container" :style="styleDynamicElement(el)" :class="el.getAnimationClass(currentElementIndex)">
        <div class="grid-container" :style="el.getStyle()">
            <component style="position: relative;" v-for="(media, index) in el.Contents" :key="index"
                class="media-element" :is="media.objectType" :el="media">
            </component>
            <div class="empty-container-message" :style="absentElementStyle" v-for="(text, index) in absentElement"
                :key="'emptyElement' + index">
                <span>
                    grille<br />
                    <strong>vide</strong><br />
                    <span class="indication">(les éléments vide ne seront pas affichés)</span>                   
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicImage from "./image.vue"
import ImageElement from "./image.vue"
import TextElement from "./text.vue"
import ColorElement from "./color.vue"
import VideoElement from "./video.vue"
import DiaporamaElement from "./diaporama.vue"
import rotation from "../../../vuexStore/type/definition/rotation.js"
import BasePreviewComponents from "./base/basePreviewComponents.vue"
export default {
    name: 'DiaporamaItem',
    extends: BasePreviewComponents,
    components: {
        DynamicImage,
        ImageElement,
        TextElement,
        ColorElement,
        VideoElement,
        DiaporamaElement
    },
    data() {
        return {
        }
    },
    computed: {
        absentElement: function() {
            if (this.el.Contents.length < this.el.X * this.el.Y) {
                return Array.from({ length: this.el.X * this.el.Y - this.el.Contents.length }, () => "empty element");
            }
            return [];
        },
        absentElementStyle: function() {
            const s = this.el.getParentSize({x: this.el.X, y: this.el.Y, gap: this.el.Gap});
            switch (this.el.Rotation) {
                case rotation.Rotate90FlipNone:
                    return { width: s.height + "px", height: s.width + "px" };
                case rotation.Rotate90FlipX:
                    return { width: s.height + "px", height: s.width + "px" };
                case rotation.Rotate90FlipY:
                    return { width: s.height + "px", height: s.width + "px" };
                case rotation.Rotate90FlipXY:
                    return { width: s.height + "px", height: s.width + "px" };
                default:
                    return { width: s.width + "px", height: s.height + "px" };
            }
        }
    },
    mounted() {
    },
    beforeUnmount() {
    },
    watch: {
    },
    methods: {
    }
}
</script>
<style scoped>
.empty-container-message {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #ffffff;
    background: #0000ff3b;
    font-size: 50px;
    font-style: italic;
    text-align: center;
    padding: 1rem;
}

.empty-container-message > span{
        pointer-events: none;
      -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
}

.indication {
    font-size: 35px;
    font-style: italic;
}
</style>
